import React, { useCallback, useState } from 'react';
import theme from './ResidentialUnitHistoryLog.module.scss';
import HistoryLogTable from '@/seller/components/HistoryLog/HistoryLogTable';
import { ButtonBar } from '@/components/Buttons';
import { HistorySearchFilters } from '@/services/object-history-log';
import HistoryLogFilterPopOut from '@/seller/components/HistoryLog/HistoryLogFilterPopOut';
import { useEffectSkipFirst } from '@/utils/hooks';
import { FilterButtons, useIsFilterModified } from '@ygtechnologies/bygr-frontend-component-library';

interface ResidentialUnitHistoryLogProps {
    residentialUnitId: number;
    projectId: number;
}

const ResidentialUnitHistoryLog = ({ residentialUnitId, projectId }: ResidentialUnitHistoryLogProps) => {
    const [filterPopUpIsOpen, setFilterPopUpIsOpen] = useState(false);
    const getDefaultFilter = useCallback((): HistorySearchFilters => {
        return {
            projectId,
            residentialUnitIds: [residentialUnitId],
        };
    }, [projectId, residentialUnitId]);

    const [filter, setFilter] = useState<HistorySearchFilters>(getDefaultFilter());

    useEffectSkipFirst(() => {
        setFilter({ ...filter, ...getDefaultFilter() });
    }, [getDefaultFilter]);
    const filterModified = useIsFilterModified(filter, getDefaultFilter);
    console.log('filter', filter);
    console.log('getDefaultFilter', getDefaultFilter());

    return (
        <>
            <ButtonBar className={theme.buttonBar}>
                <ButtonBar.Right>
                    <FilterButtons onButtonClick={() => setFilterPopUpIsOpen(true)} isActive={filterModified} />
                </ButtonBar.Right>
            </ButtonBar>
            <div className={theme.wrapper}>
                <HistoryLogTable filter={filter} />
            </div>
            <HistoryLogFilterPopOut
                onChange={setFilter}
                filter={filter}
                toggle={() => {
                    setFilterPopUpIsOpen(false);
                }}
                show={filterPopUpIsOpen}
            />
        </>
    );
};

export default ResidentialUnitHistoryLog;
